import { IModuleProps } from '@audacy-clients/core/components/ModuleRenderer/types';

import LiveNowWithState from '~/components/LiveNow';

const ModuleLiveNow: React.FC<IModuleProps> = ({ module }) => {
  return <LiveNowWithState isStation module={module} />;
};

export default ModuleLiveNow;
